import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface FadeUpProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: React.ElementType;
}
export function FadeUp({
  children,
  delay = 0,
  className = '',
  as: Component = 'div'
}: FadeUpProps) {
  const MotionComponent = motion(Component as any);
  return <MotionComponent initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-10%'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-99">
      {children}
    </MotionComponent>;
}